import React, { Fragment, useEffect, useState } from 'react';
import {
   Component,
   TaskStore,
   TaskActions,
   AccountStore,
   SettingsStore,
   LocationStore,
   LocationActions,
   TeamStore,
   PositionStore,
   PeopleActions,
   StaffMemberStore,
   TaskReportActions,
   NavigationActions,
   RoutineStore,
   RoutineActions
} from '../../../../client';
import LockDown from '../../../../components/security/LockDown';
import { lodash as _, constants } from '../../../../common';
import { Page, PageContent, PageHeader, PageListFooter } from '../../../../components/ux/Page';
import Button from '@material-ui/core/Button';
import TaskFilters from '../../../../components/tasks/TaskFilters';
import TaskObserveSelectionBar from '../../../../components/tasks/TaskObserveSelectionBar';
import Badge from '@material-ui/core/Badge';
import BreadCrumbs from '../../../../components/navigation/BreadCrumbs';

import SearchBox from '../../../../components/ux/SearchBox';
import TaskList from '../../../../components/tasks/TaskList';
import TaskListHeader from '../../../../components/tasks/TaskListHeader';
import LoadingBox from '../../../../components/feedback/LoadingBox';
import DataLoader from '../../../../components/data/DataLoader';
import LinkButton from '../../../../components/ux/Buttons/LinkButton';
import { EditIcon, EditFiltersIcon, FiltersIcon, GoogleSheetsIcon } from '../../../../components/icons';
import SweetAlert from '../../../../components/feedback/SweetAlert';
import Typography from '@material-ui/core/Typography';
import TaskGroupBy from '../../../../components/tasks/TaskGroupBy';
import TaskDashboardSyncWarning from '../TaskDashboardSyncWarning';
import { clearDashboardSyncStatusFollowUp, scheduleDashboardSyncStatusFollowUp } from '../dashboardSyncStatusFollowUp';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Popper from '@material-ui/core/Popper';
import TaskReportRowActions from './TaskReportRowActions';
import OnlineApi from '../../../../services/onlineApi';
import { canOfferTaskExcelAction } from './taskExcelActionEligibility';

const { taskFilterTypes } = constants;

const parseSpreadsheetId = (value) => {
   const raw = (value || '').trim();
   if (!raw) {
      return null;
   }

   const match = raw.match(/\/spreadsheets\/d\/([a-zA-Z0-9-_]+)/);
   const candidate = match ? match[1] : raw;

   return /^[a-zA-Z0-9-_]{20,}$/.test(candidate) ? candidate : null;
};

const AutocompletePopper = (props) => (
   <Popper
      {...props}
      style={{
         ...props.style,
         zIndex: 20000
      }}
   />
);

class TasksBook extends Component {
   constructor(props) {
      super(props);

      this.state = {
         isOpen: false,
         isSaveFiltersRequested: false,
         isExportRequested: false,
         exportSpreadsheetInput: '',
         exportErrorMessage: '',
         isExporting: false,
         exportSuccessUrl: null
      };
      this.stores = [TaskStore, AccountStore, SettingsStore, LocationStore, TeamStore, PositionStore, StaffMemberStore, RoutineStore];
      this.listenables = [TaskActions, TaskReportActions];
      this.storekeys = [
         'appliedFilters_ts',
         'allTags',
         'taskTypes',
         'locations',
         'teams',
         'positions',
         'staff',
         'stale_ts',
         'fetchParameters_ts',
         'filteredTasks_ts',
         'routines',
         'selectedTaskNos_ts',
         'paging_ts',
         'pagingfilters_ts',
         'searchText_ts',
         'currentReport_ts',
         'initialFilters_ts',
         'groupings_ts',
         'appliedGroupBy_ts',
         'initialGroupBy_ts',
         'taskDashboardSyncStatus_ts'
      ];

      this._fetchTasks = this._fetchTasks.bind(this);
      this._refreshDashboardSyncStatus = this._refreshDashboardSyncStatus.bind(this);
      this._onDashboardSyncStatusCompleted = this._onDashboardSyncStatusCompleted.bind(this);
      this._lastDashboardSyncStatus = null;
      this._dashboardSyncStatusFollowUpOwnerId = 'task-report-logbook';

      this._onEditReportClicked = this._onEditReportClicked.bind(this);
      this._onSaveCurrentFiltersClicked = this._onSaveCurrentFiltersClicked.bind(this);
      this._onSaveCurrentFiltersConfirmed = this._onSaveCurrentFiltersConfirmed.bind(this);
      this._onSaveCurrentFiltersCancelled = this._onSaveCurrentFiltersCancelled.bind(this);
      this._onExportToGoogleSheetsClicked = this._onExportToGoogleSheetsClicked.bind(this);
      this._onExportToGoogleSheetsConfirmed = this._onExportToGoogleSheetsConfirmed.bind(this);
      this._onExportToGoogleSheetsCancelled = this._onExportToGoogleSheetsCancelled.bind(this);
      this._onExportSpreadsheetInputChanged = this._onExportSpreadsheetInputChanged.bind(this);
   }

   componentDidMount() {
      const { locations, teams, positions, routines, stale_ts } = this.state;

      if (routines.length == 0) {
         RoutineActions.fetchAllRoutines();
      }

      if (!stale_ts) {
         this._refreshDashboardSyncStatus();
      }
   }

   componentWillUnmount() {
      clearDashboardSyncStatusFollowUp(this._dashboardSyncStatusFollowUpOwnerId);
   }

   _buildReportFetchArgs() {
      const { fetchParameters_ts, pagingfilters_ts, appliedGroupBy_ts } = this.state;

      let args = { groupBy: appliedGroupBy_ts, limit: pagingfilters_ts.limit, page: pagingfilters_ts.page, ...fetchParameters_ts };
      args.showLoader = true;

      return args;
   }

   _refreshDashboardSyncStatus() {
      TaskActions.getTasksDashboardSyncStatus(this._buildReportFetchArgs());
   }

   _isNonOkDashboardSyncStatus(syncStatus) {
      return syncStatus && syncStatus.status && syncStatus.status !== 'ok';
   }

   _onDashboardSyncStatusCompleted(syncStatus) {
      const previousStatus = this._lastDashboardSyncStatus;
      this._lastDashboardSyncStatus = syncStatus;

      if (this._isNonOkDashboardSyncStatus(previousStatus) && syncStatus && syncStatus.status === 'ok') {
         clearDashboardSyncStatusFollowUp(this._dashboardSyncStatusFollowUpOwnerId);
         this._fetchTasks({ skipSyncStatus: true });
         return;
      }

      if (syncStatus && syncStatus.status === 'ok') {
         clearDashboardSyncStatusFollowUp(this._dashboardSyncStatusFollowUpOwnerId);
         return;
      }

      scheduleDashboardSyncStatusFollowUp({
         ownerId: this._dashboardSyncStatusFollowUpOwnerId,
         syncStatus,
         refreshStatus: this._refreshDashboardSyncStatus
      });
   }

   _fetchTasks({ skipSyncStatus = false } = {}) {
      const args = this._buildReportFetchArgs();

      TaskActions.fetchTasksSummary(args);

      if (!skipSyncStatus) {
         TaskActions.getTasksDashboardSyncStatus(args);
      }
   }

   onGetTasksDashboardSyncStatusCompleted(response) {
      const syncStatus = response.data && response.data.content ? response.data.content.syncStatus : null;
      this._onDashboardSyncStatusCompleted(syncStatus);
   }

   _onToggleFilters = () => {
      const { isOpen } = this.state;
      this.setState({ isOpen: !isOpen });
   };

   _onCloseFilters = () => {
      this.setState({ isOpen: false });
   };

   _onChangePage = (data) => {
      const { pagingfilters_ts } = this.state;
      const limit = pagingfilters_ts.limit;
      TaskActions.setPagingFiltersSync({ page: data.page, limit });
   };

   _onChangeRowsPerPage = (data) => {
      const { pagingfilters_ts } = this.state;
      const page = pagingfilters_ts.page;

      TaskActions.setPagingFiltersSync({ page, limit: data.rowsPerPage });
   };

   _onTaskSelected = (e) => {};

   _onTaskSearchTextChange = (searchText) => {
      TaskActions.unselectAllTasksSync();
      TaskActions.setSearchTextSync(searchText);
   };

   getFiltersAppliedToFilterBox = (appliedFilters_ts) => {
      return appliedFilters_ts ? appliedFilters_ts.filter((filter) => filter.idFilterType !== taskFilterTypes.SEARCH_TEXT.id) : [];
   };

   _onReturnToReportList = () => {
      NavigationActions.to({ to: '/app/observe/task-reports' });
   };

   _onEditReportClicked() {
      const { currentReport_ts } = this.state;

      const { noReport } = currentReport_ts;

      const url = `/app/observe/tasks/edit/${noReport}`;

      NavigationActions.to({ to: url });
   }

   _onSaveCurrentFiltersClicked() {
      this.setState({ isSaveFiltersRequested: true });
   }

   _onSaveCurrentFiltersConfirmed = () => {
      const { appliedFilters_ts, appliedGroupBy_ts, currentReport_ts } = this.state;

      const { noReport } = currentReport_ts;
      let args = { noReport, filters: appliedFilters_ts, groups: appliedGroupBy_ts };

      TaskReportActions.updateTaskReportSettings({
         ...args,
         showSuccess: { message: `The current filters and grouping have been applied.` }
      });

      this.setState({ isSaveFiltersRequested: false });
   };

   _onSaveCurrentFiltersCancelled = () => {
      this.setState({ isSaveFiltersRequested: false });
   };

   _onExportToGoogleSheetsClicked() {
      this.setState({
         isExportRequested: true,
         exportSpreadsheetInput: '',
         exportErrorMessage: ''
      });
   }

   _onExportSpreadsheetInputChanged(e) {
      this.setState({
         exportSpreadsheetInput: e.target.value,
         exportErrorMessage: ''
      });
   }

   _onExportToGoogleSheetsCancelled() {
      if (this.state.isExporting) {
         return;
      }

      this.setState({
         isExportRequested: false,
         exportSpreadsheetInput: '',
         exportErrorMessage: '',
         isExporting: false
      });
   }

   _onExportToGoogleSheetsConfirmed() {
      const { exportSpreadsheetInput, fetchParameters_ts, pagingfilters_ts, appliedGroupBy_ts, currentReport_ts, isExporting } = this.state;
      if (isExporting) {
         return;
      }
      const idSpreadsheet = parseSpreadsheetId(exportSpreadsheetInput);

      if (!idSpreadsheet) {
         this.setState({
            exportErrorMessage: 'Please enter a valid Google Sheets URL or spreadsheet ID.'
         });
         return;
      }

      this.setState({ isExporting: true, exportErrorMessage: '' });

      TaskActions.exportTasksReportToGoogleSheets({
         noReport: currentReport_ts.noReport,
         idSpreadsheet,
         groupBy: appliedGroupBy_ts,
         limit: pagingfilters_ts.limit,
         page: pagingfilters_ts.page,
         ...fetchParameters_ts,
         ignoreErrorFeedback: true
      });
   }

   onExportTasksReportToGoogleSheetsCompleted(response) {
      const exportResult = response?.data?.content || {};
      this.setState({
         isExporting: false,
         isExportRequested: false,
         exportSpreadsheetInput: '',
         exportErrorMessage: '',
         exportSuccessUrl: exportResult.spreadsheetUrl || null
      });
   }

   onExportTasksReportToGoogleSheetsFailed(_response) {
      this.setState({
         isExporting: false,
         exportErrorMessage: 'We could not export right now. Please check the spreadsheet and try again.'
      });
   }

   _onDismissExportSuccess = () => {
      this.setState({ exportSuccessUrl: null });
   };

   render() {
      const {
         appliedFilters_ts,
         allTags,
         taskTypes,
         locations,
         teams,
         positions,
         staff,
         isOpen,
         filteredTasks_ts,
         selectedTaskNos_ts,
         searchText_ts,
         paging_ts,
         routines,
         groupings_ts,
         currentReport_ts,
         initialFilters_ts,
         stale_ts,
         isSaveFiltersRequested,
         appliedGroupBy_ts,
         initialGroupBy_ts,
         isExportRequested,
         exportSpreadsheetInput,
         exportErrorMessage,
         isExporting,
         exportSuccessUrl,
         taskDashboardSyncStatus_ts
      } = this.state;

      const canDisplayFilters = locations.length != 0 && teams.length != 0 && staff.length != 0;

      const noOfFilters = this.getFiltersAppliedToFilterBox(appliedFilters_ts).length;

      const crumbs = [{ name: 'Task Reports', onClick: this._onReturnToReportList }];

      const routineTags = allTags
         ? _.filter(allTags, (t) => {
              return t.noTagType == constants.tagTypes.ROUTINE.id;
           })
         : [];
      const allowlistedSpreadsheetIds = _.get(currentReport_ts, 'options.integrations.googleSheets.idsAllowedSpreadsheets', []);

      let actions = [
         { icon: <EditIcon />, name: 'Edit report details', onClick: this._onEditReportClicked },
         { icon: <EditFiltersIcon />, name: 'Update filters and groups', onClick: this._onSaveCurrentFiltersClicked }
      ];

      let canExport = false;
      try {
         canExport = AccountStore.singleton.allowed('MANAGE_TASKS');
      } catch (error) {
         canExport = false;
      }

      if (canExport) {
         actions.push({
            icon: <GoogleSheetsIcon />,
            name: 'Export to Google Sheets',
            onClick: this._onExportToGoogleSheetsClicked
         });
      }

      return (
         <div className='app-wrapper'>
            <DataLoader stale={stale_ts} loadMethod={this._fetchTasks} />
            <BreadCrumbs crumbs={crumbs} />
            <LockDown permission='VIEW_PEOPLE' redirectTo={'/app/home'}>
               <Page className={'TaskBook'}>
                  <PageHeader
                     title={currentReport_ts.name}
                     actions={actions}
                     subtitle={currentReport_ts.description}
                     bar={true}
                     componentTopRight={<TaskGroupBy groupBy={appliedGroupBy_ts} initialGroupBy={initialGroupBy_ts} />}
                     componentBottom={
                        <>
                           <TaskObserveSelectionBar selected='logbook' noReport={currentReport_ts.noReport} />
                           <div style={{ position: 'absolute', left: '50%' }}>
                              <div style={{ position: 'relative', left: '-50%' }}>
                                 <SearchBox
                                    searchText={searchText_ts}
                                    placeholder={'Search for tasks'}
                                    onChange={this._onTaskSearchTextChange}
                                 />
                              </div>
                           </div>
                           <TaskListHeader />
                        </>
                     }
                     componentLeft={
                        canDisplayFilters && (
                           <div style={{ position: 'relative' }}>
                              <Badge color='secondary' overlap='circular' badgeContent={noOfFilters}>
                                 <Button
                                    disabled={false}
                                    onClick={this._onToggleFilters}
                                    id={'show-filters-btn'}
                                    variant='contained'
                                    color='primary'
                                    className='btn transform-none filter-btn'>
                                    <>
                                       <FiltersIcon className='ico' />
                                       Filters
                                    </>
                                 </Button>
                              </Badge>
                           </div>
                        )
                     }
                  />

                  <PageContent margin={'none'} style={{ position: 'relative', flex: 1 }}>
                     <TaskDashboardSyncWarning syncStatus={taskDashboardSyncStatus_ts} />
                     {canDisplayFilters && (
                        <TaskFilters
                           isOpen={isOpen}
                           onCloseFilters={this._onCloseFilters}
                           appliedFilters={appliedFilters_ts}
                           initialFilters={initialFilters_ts}
                           allTags={allTags}
                           taskTypes={taskTypes}
                           locations={locations}
                           teams={teams}
                           positions={positions}
                           staff={staff}
                           routines={routines}
                        />
                     )}
                     <LoadingBox loadingTypes={[{ messageType: 'FETCH_TASKS' }]}>
                        <>
                           <TaskList
                              groupBy={appliedGroupBy_ts}
                              groups={groupings_ts}
                              tasks={filteredTasks_ts}
                              taskTypes={taskTypes}
                              locations={locations}
                              teams={teams}
                              positions={positions}
                              staff={staff}
                              selectedTaskNos={selectedTaskNos_ts}
                              taskPaging={paging_ts}
                              availableTags={routineTags}
                              routines={routines}
                              onTaskSelected={this._onTaskSelected}
                              renderTaskActions={(task) =>
                                 canOfferTaskExcelAction(task, AccountStore.singleton.allowed('MANAGE_TASKS'), constants.taskTimingStates.COMPLETE)
                                    ? <TaskReportRowActions
                                         noTask={task.noTask}
                                         taskName={task.name}
                                         checkEligibility={OnlineApi.getTaskExcelEligibility}
                                         downloadWorkbook={OnlineApi.downloadTaskExcel}
                                      />
                                    : null
                              }
                           />
                        </>
                     </LoadingBox>
                     <PageListFooter paging={paging_ts} onChangePage={this._onChangePage} onChangeRowsPerPage={this._onChangeRowsPerPage} />
                  </PageContent>
               </Page>
            </LockDown>
            {isSaveFiltersRequested && (
               <SweetAlert
                  show={true}
                  warning
                  showCancel
                  confirmBtnText={'Replace'}
                  cancelBtnText={'Cancel'}
                  confirmBtnBsStyle='warning'
                  cancelBtnBsStyle='default'
                  title={'Replace filters and groups?'}
                  onConfirm={this._onSaveCurrentFiltersConfirmed}
                  onCancel={this._onSaveCurrentFiltersCancelled}>
                  <Typography>Replace the report filters and groups with the current selected ones?</Typography>
               </SweetAlert>
            )}
            {isExportRequested && (
               <SweetAlert
                  show={true}
                  warning
                  showCancel
                  confirmBtnText={isExporting ? 'Exporting...' : 'Export'}
                  cancelBtnText={'Cancel'}
                  confirmBtnBsStyle='warning'
                  cancelBtnBsStyle='default'
                  title={'Export to Google Sheets'}
                  onConfirm={this._onExportToGoogleSheetsConfirmed}
                  onCancel={this._onExportToGoogleSheetsCancelled}>
                  <Typography>Paste a Google Sheets URL or spreadsheet ID.</Typography>
                  {allowlistedSpreadsheetIds.length > 0 ? (
                     <Autocomplete
                        PopperComponent={AutocompletePopper}
                        freeSolo
                        options={allowlistedSpreadsheetIds}
                        value={exportSpreadsheetInput}
                        onChange={(_event, newValue) => {
                           this.setState({
                              exportSpreadsheetInput: newValue || '',
                              exportErrorMessage: ''
                           });
                        }}
                        onInputChange={(_event, newInputValue) => {
                           this.setState({
                              exportSpreadsheetInput: newInputValue || '',
                              exportErrorMessage: ''
                           });
                        }}
                        disabled={isExporting}
                        renderInput={(params) => (
                           <TextField
                              {...params}
                              autoFocus
                              margin='dense'
                              fullWidth
                              label='Google Sheets spreadsheet'
                              placeholder='https://docs.google.com/spreadsheets/d/...'
                           />
                        )}
                     />
                  ) : (
                     <TextField
                        autoFocus
                        margin='dense'
                        fullWidth
                        value={exportSpreadsheetInput}
                        onChange={this._onExportSpreadsheetInputChanged}
                        disabled={isExporting}
                        placeholder='https://docs.google.com/spreadsheets/d/...'
                     />
                  )}
                  {exportErrorMessage && (
                     <Typography style={{ marginTop: 8 }} color='error'>
                        {exportErrorMessage}
                     </Typography>
                  )}
               </SweetAlert>
            )}
            {exportSuccessUrl && (
               <SweetAlert
                  show={true}
                  warning
                  showCancel={false}
                  confirmBtnText={'OK'}
                  cancelBtnText={'Close'}
                  confirmBtnBsStyle='warning'
                  cancelBtnBsStyle='default'
                  title={'Export complete'}
                  onConfirm={this._onDismissExportSuccess}
                  onCancel={this._onDismissExportSuccess}>
                  <Typography>Submission export completed successfully.</Typography>
                  <div style={{ marginTop: 8 }}>
                     <LinkButton href={exportSuccessUrl} target='_blank' rel='noopener noreferrer'>
                        {exportSuccessUrl}
                     </LinkButton>
                  </div>
               </SweetAlert>
            )}
         </div>
      );
   }
}

export default TasksBook;
